<template>
    <tailwind-layout title="Application Details">
        <template #header>
            Application Details
        </template>
        <div class="bg-rent-risk-blue-100 overflow-hidden shadow-xl sm:rounded-lg p-6">
            <div class="space-y-8 divide-y divide-gray-200">
                <div class="pt-8">
                    <div>
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Personal Information
                        </h3>
                        <p class="mt-1 text-sm text-gray-500">
                            We will include all relevant information on this page including the credit reports and other reports that are generated from the application process.
                        </p>
                    </div>
                    <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                        <div class="sm:col-span-3">
                            <label class="block text-sm font-medium text-gray-700">
                                Name
                            </label>
                            <div class="mt-1">
                                {{ application.name }}
                            </div>
                        </div>

                        <div class="sm:col-span-4">
                            <label class="block text-sm font-medium text-gray-700">
                                Email address
                            </label>
                            <div class="mt-1">
                                {{ application.email }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pt-5">
                <div class="flex justify-end">
                    <inertia-link :href="route('applications.index')" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">Cancel</inertia-link>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'

export default {
    props: {
        application: Object,
    },
    components: {
        TailwindLayout,
        LoadingButton,
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>
